<template>
  <div class="page relate-protocol">
    <navigation>服务协议</navigation>
    <div class="header">
      <p class="description"></p>
    </div>
    <nd-cell class="navigate-item" v-for="(item, index) in protocolList" :id="index" :key="index" :title="item.name" @click="routerToProtocol(item.path)"></nd-cell>
  </div>
</template>

<script>

export default {
  name: 'accountMineProtocol',
  customReadyNotify: true,
  data () {
    return {
      protocolList: [
        { name: '《用户注册及服务协议》', path: '/tmd/protocol/login' },
        { name: '《隐私政策》', path: '/tmd/protocol/privacy' }
      ]
    }
  },

  async created () {
    this.$bus.$emit('ready')
  }

 
}
</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

  .relate-protocol {
      background-color: #fafafa;

      .header {
          .description {
            color: @fc2;
            font-family: PingFangSC-Regular,PingFang SC;
            font-size: 26px;
            line-height: 100px;
            padding-left: 30px;
            font-weight: 400;
         }
      }

      .navigate-item {
          height: 110px;
          line-height: 110px;
          margin-top: 0px;
          padding-left: 15px;
          padding-right: 17px;
          border-bottom: 1px solid @iuc;
      }
  }
</style>